export type ResourceType = "document" | "link" | "contractor_document";

export const RESOURCE_TYPE_LABELS: Record<ResourceType, string> = {
  document: "Dokument",
  link: "Link",
  contractor_document: "Dok. podwykonawcy",
};

export interface ResourceCategory {
  id: string;
  name: string;
  description: string;
  order: number;
  created_at: string;
  /** True when the current user may fully manage this category and its resources. */
  can_manage: boolean;
}

export interface AccessGroupMember {
  id: string;
  name: string;
  role: string;
}

export interface AccessGroupContractor {
  id: string;
  name: string;
}

export interface AccessGroup {
  id: string;
  name: string;
  members: AccessGroupMember[];
  contractors: AccessGroupContractor[];
  created_at: string;
}

export interface DocumentVersion {
  id: string;
  version_number: number;
  url: string;
  original_name: string;
  file_size: number | null;
  change_comment: string;
  uploaded_by_name: string | null;
  created_at: string;
}

export interface ResourceManager {
  id: string;
  name: string;
}

export interface ResourceAccess {
  roles: string[];
  individual_users: string[];
  individual_user_names: { id: string; name: string }[];
  /** Only the current user's own attached groups. */
  groups: { id: string; name: string }[];
  /** Count of attached groups owned by other users (not editable here). */
  other_groups_count: number;
}

export interface ContractorResourceAccess {
  contractors: string[];
  contractor_names: { id: string; name: string }[];
}

export interface Resource {
  id: string;
  title: string;
  description: string;
  resource_type: ResourceType;
  category_id: string;
  category_name: string;
  url: string;
  latest_version: DocumentVersion | null;
  created_by_name: string | null;
  managers: ResourceManager[];
  is_subscribed: boolean;
  /** True when the current user may fully manage this resource (edit/delete/access). */
  can_manage: boolean;
  created_at: string;
  updated_at: string;
}

export interface ResourceDetail extends Resource {
  versions: DocumentVersion[];
  access: ResourceAccess | null;
  contractor_access: ContractorResourceAccess | null;
}

export const ALL_ROLES = [
  { value: "coordinator", label: "Koordynator" },
  { value: "accountant", label: "Księgowość" },
  { value: "employee", label: "Pracownik" },
  { value: "hr", label: "Kadrowa" },
];
